/**
 * SIGNALING_ADAPTER_EVENT_TYPE
 * ----------------------------
 *
 * Transport-facing signaling adapter event vocabulary.
 *
 * These events describe the lifecycle of the signaling transport itself.
 * Raw server protocol frames are delivered separately via subscribeFrames(...).
 */
export const SIGNALING_ADAPTER_EVENT_TYPE = {
    CONNECTING: "CONNECTING",
    OPEN: "OPEN",
    CLOSED: "CLOSED",
    ERROR: "ERROR",
};
